import { BObjectModel, PropertyData, PropertyGroup } from '../bodisplay';
import { QueovalBase, HtmlBase, QueovalDate } from '../global';
import { ModelMail } from '../mail';

//import { ModelMail } from '../elearning';

export class ZoomModel extends QueovalBase {
  message: string;
  Secret: string;
  Key: string;
  start_time_bo: string;
  duration_bo: number | null;
  userOfAgenda: UserOfAgenda;
  User: ZoomUser;
  UserGroup: ZoomUserGroup;
  Meeting: ZoomMeeting;
  MeetingArray: ZoomMeetingArray;
  ZoomEventsModel: ZoomEventsModel;
  ZoomBoProperties: ZoomBoProperties;
  MailModel: ZoomMailModel;
  recording: ZoomRecording;

  constructor() {
    super();
    this.message = '';
    this.Secret = '';
    this.Key = '';
    this.start_time_bo = '';
    this.duration_bo = null;
    this.userOfAgenda = new UserOfAgenda();
    this.Meeting = new ZoomMeeting();
    this.ZoomEventsModel = new ZoomEventsModel();
    this.MailModel = new ZoomMailModel();
    this.ZoomBoProperties = new ZoomBoProperties();
  }
}

export class ZoomRecording {
  public uuid: string;
  public id: number;
  public account_id: string;
  public host_id: string;
  public topic: string;
  public type: number;
  public start_time: string;
  public timezone: string;
  public duration: number;
  public total_size: number;
  public recording_count: number;
  public share_url: string;
  public recording_files: Array<ZoomRecordingFile>;
}
export class ZoomRecordingFile {
  public id: string;
  public meeting_id: string;
  public recording_start: string;
  public recording_end: string;
  public file_type: string;
  public file_size: number;
  public play_url: string;
  public status: string;
  public deleted: string;
  public recording_type: string;
}


export class ZoomMailModel {
  public ListModelsMail: Array<ModelMail>;
  public ModelMailSelected: ModelMail;
  constructor() {
    this.ListModelsMail = new Array<ModelMail>();
    this.ModelMailSelected = new ModelMail();
  }
}
export class UserOfAgenda {
  public strIdent: string;
  public strZoomEmail: string;
  public strNeproPER: string;

  constructor(strIdent: string = '') {
    this.strIdent = strIdent;
    this.strNeproPER = '';
    this.strZoomEmail = '';
  }
}

export class ZoomBoProperties {
  idBoFils: string;
  NomBO: string;
  ZoomLink: string;
  constructor() {
    this.idBoFils = '';
    this.NomBO = '';
    this.ZoomLink = '';
  }
}

export class ZoomUser {
  email: string;
  first_name: string;
  id: string;
  last_name: string;
  type: number;
  password: string;
  registrant_id: string;

  constructor() {
    this.email = '';
    this.first_name = '';
    this.id = '';
    this.last_name = '';
    this.type = 0;
    this.password = '';
    this.registrant_id = '';
  }
}

export class ZoomUserGroup {
  name: string;
  page_count: number;
  page_number: number;
  page_size: number;
  total_records: number;
  registrants: Array<ZoomUser>;
  constructor() {
    this.name = '';
    this.page_count = 0;
    this.page_number = 0;
    this.page_size = 0;
    this.total_records = 0;
    this.registrants = new Array<ZoomUser>();
  }
}

export class ZoomMeeting {
  uuid: string;
  id: string;
  host_id: string;
  topic: string;
  type: number;
  start_time: string;
  duration: number;
  timezone: string;
  created_at: string;
  agenda: string;
  start_url: string;
  join_url: string;
  password: string;
  h323_password: string;
  occurrences: Array<ZoomMeetingOccurrences>;
  settings: ZoomMeetingSetting;
  recurrence: ZoomMeetingRecurrence;
  constructor() {
    this.password = '';
    // récupération des infos dans le local storage
    const st: string | null = sessionStorage.getItem('zoomSettings');
    if (st) {
      const _password: string = JSON.parse(st).password;
      this.password = _password;
    }
    this.uuid = '';
    this.id = '';
    this.host_id = '';
    this.topic = '';
    this.type = 0;
    this.start_time = '';
    this.duration = 0;
    this.timezone = '';
    this.created_at = '';
    this.agenda = '';
    this.start_url = '';
    this.join_url = '';
    this.settings = new ZoomMeetingSetting();
    this.h323_password = '';
  }
}

export class ZoomMeetingOccurrences {
  occurrences_id: number;
  start_time: string;
  duration: number;
  status: string;
  constructor() {
    this.occurrences_id = 0;
    this.start_time = '';
    this.duration = 0;
    this.status = '';
  }
}

export class ZoomMeetingSetting {
  host_video: boolean;
  //participant_video: boolean;
  //cn_meeting: boolean;
  //in_meeting: boolean;
  join_before_host: boolean;
  mute_upon_entry: boolean;
  //watermark: boolean;
  //use_pmi: boolean;
  //approval_type: number;
  //registration_type: number;
  //audio: string;
  auto_recording: string;
  //enforce_login: boolean;
  //enforce_login_domains: string;
  //alternative_hosts: Array<string>;
  //// spécifiques au webinaire
  //practice_session: boolean;
  //hd_video: boolean;
  //close_registration: boolean;
  //show_share_button: boolean;
  //allow_multiple_devices: boolean;
  //panelists_video: boolean;
  constructor() {
    // récupération des infos dans le local storage
    if (sessionStorage.getItem('zoomSettings')) {
      const st: string | null = sessionStorage.getItem('zoomSettings');
      if (st) {
        const settings: ZoomMeetingSetting = JSON.parse(st).settings;
        ////this.participant_video = settings.participant_video;
        ////// Options propres aux webinaires
        ////this.practice_session = settings.practice_session;
        ////this.hd_video = settings.hd_video;
        ////this.close_registration = settings.close_registration;
        ////this.show_share_button = settings.show_share_button;
        ////this.allow_multiple_devices = settings.allow_multiple_devices;
        ////this.panelists_video = settings.panelists_video;
        // Options communes:
        this.host_video = settings.host_video;
        //this.cn_meeting = settings.cn_meeting;
        //this.in_meeting = settings.in_meeting;
        this.join_before_host = settings.join_before_host;
        this.mute_upon_entry = settings.mute_upon_entry;
        //this.watermark = settings.watermark;
        //this.use_pmi = settings.use_pmi;
        //this.approval_type = settings.approval_type;
        //this.registration_type = settings.registration_type;
        //this.audio = settings.audio;
        this.auto_recording = settings.auto_recording;
        //this.enforce_login = settings.enforce_login;
        //this.enforce_login_domains = settings.enforce_login_domains;
        //this.alternative_hosts = settings.alternative_hosts;
        // valeurs par défaut si pas de local storage

      }
    } else {
      ////this.participant_video = false;
      ////// Options propres aux webinaires
      ////this.practice_session = false;
      ////this.hd_video = true;
      ////this.close_registration = false;
      ////this.show_share_button = false;
      ////this.allow_multiple_devices = false;
      ////this.panelists_video = false;

      // Options communes:
      this.host_video = false;
      ////this.cn_meeting = false;
      ////this.in_meeting = false;
      this.join_before_host = false;
      this.mute_upon_entry = true;
      ////this.watermark = false;
      ////this.use_pmi = false;
      ////// types : 0 = approuvé automatiquement ; 1 = approuvé manuellement; 2 = pas d'enregistrement requis
      ////this.approval_type = 0;
      ////// type 1 = Les participants s'inscrivent une fois et peuvent assister à toutes les occurrences.
      ////// type 2 = Les participants doivent s'inscrire pour chaque événement.
      ////// type 3 = Les participants s'inscrivent une fois et peuvent choisir une ou plusieurs occurrences.
      ////this.registration_type = 2;
      ////// Déterminez comment les participants peuvent rejoindre la partie audio de la réunion
      ////// string 1: both =  Téléphonie et VoIP
      ////// string 2: telephony
      ////// string 3: voip
      ////this.audio = 'both';
      // strings: local, cloud, none (default:none)
      this.auto_recording = 'none';
      // Seuls les utilisateurs connectés peuvent rejoindre cette réunion.
      ////this.enforce_login = false;
      ////// Seuls les utilisateurs connectés avec des domaines spécifiés peuvent rejoindre des réunions.
      ////this.enforce_login_domains = '';
      ////// Autres adresses e - mail ou identifiants d'animateurs Valeur multiple: string séparée par des virgules.
      ////this.alternative_hosts = [];
    }
  }
}

export class ZoomMeetingRecurrence {
  type: number;
  repeat_interval: number;
  weekly_days: string;
  monthly_day: number;
  monthly_week: number;
  monthly_week_day: number;
  end_times: number;
  end_date_time: string;
  constructor() {
    this.type = 1;
    this.repeat_interval = 1;
    this.weekly_days = 'null';
    this.monthly_day = 1;
    this.monthly_week = 1;
    this.monthly_week_day = 1;
    this.end_times = 1;
    this.end_date_time = '';
  }
}

export class ZoomMeetingArray {
  page_count: number;
  page_number: number;
  page_size: number;
  total_records: number;
  type: string;
  meetings: ZoomMeeting[];
  constructor() {
    this.page_count = 0;
    this.page_number = 0;
    this.page_size = 0;
    this.total_records = 0;
    this.type = '';
    this.meetings = new Array<ZoomMeeting>();
  }
}
export class ZoomEventsModel extends QueovalBase {
  public ListZoomFormateur: Array<ZoomFormateur>;
  public Lieu: BObjectModel;
  public ListZoomContacts: Array<ZoomContact>;
  public ListZoomStage: Array<ZoomStage>;
  public ListZoomApprenant: Array<ZoomApprenant>;
  public IdStage: string;
  public Code: string;
  public Ident: string;
  constructor() {
    super();
    this.ListZoomFormateur = new Array<ZoomFormateur>();
    this.Lieu = new BObjectModel;
    this.ListZoomStage = new Array<ZoomStage>();
    this.ListZoomApprenant = new Array<ZoomApprenant>();
    this.IdStage = '';
    this.Code = '';
    this.Ident = '';
  }
}

export class ZoomContact {
  public strIdent: string;
  public strEmail: string;
  public strNom: string;
  public strPrenom: string;
  public etat: string;
}

export class ZoomApprenant {
  public strIdZoomAPI: string;
  public BOModel: BObjectModel;
  public strIdent: string;
  public strNom: string;
  public strPrenom: string;
  public strEmail: string;
  public check: boolean;
  public etat: string;
  public isValid: boolean;
  public isSended: boolean;
  constructor() {
    this.strIdZoomAPI = '';
    this.BOModel = new BObjectModel;
    this.strIdent = '';
    this.strNom = '';
    this.strPrenom = '';
    this.strEmail = '';
    this.check = false;
    this.etat = '';
    this.isValid = false;
    this.isSended = false;
  }
}
export class ZoomFormateur {
  public BOModel: BObjectModel;
  public strCivilite: string;
  public strNom: string;
  public strPrenom: string;
  public strEmail: string;
  constructor() {
    this.BOModel = new BObjectModel;
    this.strCivilite = '';
    this.strNom = '';
    this.strPrenom = '';
    this.strEmail = '';
  }
}
export class ZoomStage {
  public BOModel: BObjectModel;
  public Text: string;
  constructor() {
    this.BOModel = new BObjectModel;
    this.Text = '';
  }
}

export class CustomSelect {
  Selected: boolean;
  Text: string;
  Value: any;
}
